module.exports = __webpack_public_path__ + "img/main_zjs.6bc58ba3.jpg";